import { useDispatch } from "react-redux";
import {
  AuthLogin,
  ConfirmEmail,
  GetFilteredSuppliers,
  Login,
  RequestResetPassword,
  ResendRecoverOTP,
  ResendSignupOTP,
  ResetPassword,
  Signup,
  UserType,
} from "../api/services/user";
import {
  ConfirmEmailProps,
  LoginProps,
  RegisterProps,
  RequestPasswordResetProps,
  ResendRecoverOTPProps,
  ResendSignupOTPProps,
  ResetPasswordProps,
  UserTypeProps,
} from "../declarations/userServices";
import { setToken, setAccount } from "../reducer/userReducer";
import CachedItem, { CacheItem } from "../config/cache";
import { useNavigate } from "react-router-dom";
import { Paths } from "../router/Paths";
import { useToast } from "./useToast";
import { toast } from "react-toastify";

import { setUserProfile } from "../reducer/userTypeReducer";

export function useUser() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showResponseMessages } = useToast();

  const login = async (query: LoginProps) => {
    const response = await Login(query);
    console.log(response);

    const { message, status, accessToken, errors, account } = response;
    if (status === 200) {
      if (accessToken) {
        CacheItem(CachedItem.token, accessToken, true);
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("account", JSON.stringify(account));

        dispatch(setToken(accessToken));
        if (account) {
          dispatch(setAccount(account));
        }
        navigate(Paths.welcome);
      }
    } else {
      showResponseMessages(status, message, errors);
    }
  };

  const authlogin = async (): Promise<void> => {
    try {
      await AuthLogin();
    } catch (error) {
      console.error("Google login failed:", error);
    }
  };

  const register = async (query: RegisterProps) => {
    const response = await Signup(query);

    const { message, status, errors } = response;
    if (status === 201) {
      navigate(`${Paths.verifyEmail}?email=${query.email}`);
    } else {
      showResponseMessages(status, message, errors);
    }
  };

  const confirmEmail = async (query: ConfirmEmailProps) => {
    const response = await ConfirmEmail(query);
    const { message, status, errors, token, account } = response;

    console.log("ConfirmEmail Response:", response);

    if (status === 200) {
      if (token) {
        localStorage.setItem("token", token);
        dispatch(setToken(token));
        CacheItem(CachedItem.token, token, true);
      }
      if (account) {
        localStorage.setItem("account", JSON.stringify(account));
        dispatch(setAccount(account));
      }
      return true;
    } else {
      showResponseMessages(status, message, errors);
      return false;
    }
  };

  const userType = async (query: UserTypeProps) => {
    try {
      const account = localStorage.getItem("account");
      const token = localStorage.getItem("token");

      console.log("Token from localStorage:", token);
      console.log("Account from localStorage:", account);

      if (token) {
        dispatch(setToken(token));
        CacheItem(CachedItem.token, token, true);
      }

      if (account) {
        dispatch(setAccount(JSON.parse(account)));
      }

      const response = await UserType(query);

      if (response) {
        const { message, success, profile } = response.data;

        if (success) {
          const token = localStorage.getItem("token");

          dispatch(setToken(token));

          navigate(Paths.welcome);
          message && toast["success"](message);
        } else {
          showResponseMessages(message);
          navigate(Paths.login);
        }
      }
    } catch (error) {
      console.error("Error in userType:", error);
      throw error;
    }
  };

  const requestPasswordReset = async (query: RequestPasswordResetProps) => {
    const response = await RequestResetPassword(query);

    const { message, status, errors } = response;
    if (status === 200) {
      navigate(`${Paths.recoverPassword}?email=${query.email}`);
    } else {
      showResponseMessages(status, message, errors);
    }
  };

  const resetPassword = async (query: ResetPasswordProps) => {
    const response = await ResetPassword(query);

    const { message, status, errors } = response;
    showResponseMessages(status, message, errors);
    if (status === 200) {
      navigate(Paths.login);
    }
  };

  const resendSignupOTP = async (query: ResendSignupOTPProps) => {
    const response = await ResendSignupOTP(query);

    const { message, status, errors } = response;
    showResponseMessages(status, message, errors);
  };

  const resendRecoverOTP = async (query: ResendRecoverOTPProps) => {
    const response = await ResendRecoverOTP(query);

    const { message, status, errors } = response;
    showResponseMessages(status, message, errors);
  };

  const getFilteredSuppliers = async (
    page: number,
    limit: number,
    searchKey: string
  ) => {
    const response = await GetFilteredSuppliers(page, limit, searchKey);
    const { message, status } = response;
    if (status === 200) {
      message && toast["success"](message);
    } else {
      message && toast["error"](message);
    }
    return response;
  };

  return {
    login,
    authlogin,
    register,
    confirmEmail,
    requestPasswordReset,
    resetPassword,
    resendSignupOTP,
    resendRecoverOTP,
    userType,
    getFilteredSuppliers,
  };
}
